import { createSelector } from '../reselect';
import { getStats, total, simpleChart, simpleChart2, simpleChart3 } from '../generalUtils';

import { chartSales, totalSales } from '../generalSelectors';

const totalAttentivePlacedOrder = createSelector([getStats], (stats) =>
  total(stats, 'attentive_placedorder_count')
);

const totalAttentivePlacedOrderTotalPriceFlows = createSelector([getStats], (stats) =>
  total(stats, 'attentive_placedorder_total_price_flows')
);

const totalAttentivePlacedOrderTotalPriceCampaigns = createSelector([getStats], (stats) =>
  total(stats, 'attentive_placedorder_total_price_campaigns')
);

const totalAttentivePlacedOrderTotalPrice = createSelector([getStats], (stats) =>
  total(stats, 'attentive_placedorder_total_price')
);

const chartAttentivePlacedOrderTotalPriceCampaigns = createSelector([getStats], (stats) =>
  simpleChart(stats, 'attentive_placedorder_total_price_campaigns')
);
const chartAttentivePlacedOrderTotalPriceFlows = createSelector([getStats], (stats) =>
  simpleChart(stats, 'attentive_placedorder_total_price_flows')
);

const totalAttentiveUnsubscribed = createSelector([getStats], (stats) =>
  total(stats, 'attentive_unsubscribed')
);

const chartAttentiveUnsubscribed = createSelector([getStats], (stats) =>
  simpleChart(stats, 'attentive_unsubscribed')
);

const totalAttentiveNewSubscribed = createSelector([getStats], (stats) =>
  total(stats, 'attentive_subscribedtolist')
);
const chartAttentiveNewSubscribed = createSelector([getStats], (stats) =>
  simpleChart(stats, 'attentive_subscribedtolist')
);

const chartAttentiveNetNewsubscribers = createSelector([getStats], (stats) =>
  simpleChart(stats, 'attentive_net_newsubscribers')
);

const totalAttentiveNetNewsubscribers = createSelector([getStats], (stats) =>
  total(stats, 'attentive_net_newsubscribers')
);

const chartAttentivePlacedOrderSalesPercentFlows = createSelector(
  [chartAttentivePlacedOrderTotalPriceFlows, chartSales],
  (chartAttentivePlacedOrderTotalPriceFlows, chartSales) => {
    var chart1 = chartAttentivePlacedOrderTotalPriceFlows;
    var chart2 = chartSales;
    return simpleChart2(chart1, chart2, { chart1yMultiplier: 100 });
  }
);

const totalAttentivePlacedOrderSalesPercentCampaigns = createSelector(
  [
    totalSales,
    totalAttentivePlacedOrderTotalPriceFlows,
    totalAttentivePlacedOrderTotalPriceCampaigns,
  ],
  (sales, flows, campaigns) => (!sales ? 0 : (100 * campaigns) / sales)
);
const totalAttentivePlacedOrderSalesPercentFlows = createSelector(
  [totalSales, totalAttentivePlacedOrderTotalPriceFlows],
  (sales, flows) => (!sales ? 0 : (100 * flows) / sales)
);

const chartAttentivePlacedOrderSalesPercentCampaigns = createSelector(
  [chartAttentivePlacedOrderTotalPriceCampaigns, chartSales],
  (chartAttentivePlacedOrderTotalPriceCampaigns, chartSales) => {
    var chart1 = chartAttentivePlacedOrderTotalPriceCampaigns;
    var chart2 = chartSales;
    return simpleChart2(chart1, chart2, { chart1yMultiplier: 100 });
  }
);
const chartAttentivePlacedOrderSalesPercent = createSelector(
  [chartAttentivePlacedOrderSalesPercentFlows, chartAttentivePlacedOrderSalesPercentCampaigns],
  (chartAttentivePlacedOrderSalesPercentFlows, chartAttentivePlacedOrderSalesPercentCampaigns) => {
    var chart1 = chartAttentivePlacedOrderSalesPercentFlows;
    var chart2 = chartAttentivePlacedOrderSalesPercentCampaigns;
    return simpleChart3(chart1, chart2, []);
  }
);

const attentivePlacedOrderSales = createSelector(
  [
    totalSales,
    totalAttentivePlacedOrderTotalPriceFlows,
    totalAttentivePlacedOrderTotalPriceCampaigns,
  ],
  (sales, flows, campaigns) => (!sales ? 0 : flows + campaigns)
);

// MAINLY FOR updateDayStats
const PROPS_TO_SELECTORS = {};

export default {
  PROPS_TO_SELECTORS,
  SELECTORS: {
    totalAttentivePlacedOrder,
    totalAttentivePlacedOrderTotalPriceFlows,
    totalAttentivePlacedOrderTotalPriceCampaigns,
    totalAttentivePlacedOrderTotalPrice,
    totalAttentivePlacedOrderSalesPercentCampaigns,
    totalAttentivePlacedOrderSalesPercentFlows,
    totalAttentiveNetNewsubscribers,
    totalAttentiveNewSubscribed,
    totalAttentiveUnsubscribed,
    chartAttentiveNetNewsubscribers,
    chartAttentiveNewSubscribed,
    chartAttentiveUnsubscribed,
    chartAttentivePlacedOrderTotalPriceFlows,
    chartAttentivePlacedOrderSalesPercentFlows,
    chartAttentivePlacedOrderTotalPriceCampaigns,
    chartAttentivePlacedOrderSalesPercentCampaigns,
    chartAttentivePlacedOrderSalesPercent,
    attentivePlacedOrderSales,
  },
};
